import paginationSelectors from 'modules/shared/pagination/paginationSelectors';
export default paginationSelectors('tool.list');
